<form
  (ngSubmit)="onSubmit()"
  [formGroup]="formGroup">
  <love-it-modal-header
    (close)="closeModal()"
    [title]="editText"></love-it-modal-header>
  <ul
    #nav="ngbNav"
    class="nav nav-tabs card-header-tabs"
    ngbNav>
    <li
      [destroyOnHide]="false"
      ngbNavItem="stammdaten">
      <a
        [invalid]="submitted && formGroup.invalid"
        label="Stammdaten"
        love-it-tab
        ngbNavLink></a>
      <ng-template ngbNavContent>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <label
                  class="required-label"
                  for="email"
                  >E-Mail</label
                >
                <input
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('email')?.errors,
                  }"
                  class="form-control"
                  formControlName="email"
                  id="email"
                  type="text" />
                @if (submitted && formGroup.get("email")?.errors) {
                  <div class="invalid-feedback">
                    @if (formGroup.get("email")?.errors["required"]) {
                      <div>E-Mail ist ein Pflichtfeld.</div>
                    }
                    @if (formGroup.get("email")?.errors["email"]) {
                      <div>Bitte geben Sie eine gültige E-Mail Adresse ein</div>
                    }
                  </div>
                }
              </div>
              @if (CaslAction.Update | permission: EntityTyp.User) {
                <div class="col-sm-6">
                  <label
                    class="required-label"
                    for="type"
                    >Rolle</label
                  >
                  <ng-select
                    [formControl]="formGroup.get('role') | formControl"
                    [items]="userRoles"
                    bindLabel="display"
                    bindValue="value"
                    [clearable]="false"
                    [searchable]="false"
                    id="type"
                    [ngClass]="{
                      'is-invalid': submitted && formGroup.get('role')?.errors,
                    }"></ng-select>
                  @if (submitted && formGroup.get("role")?.errors) {
                    <div class="invalid-feedback">
                      @if (formGroup.get("role")?.errors["required"]) {
                        <div>Rolle ist ein Pflichtfeld.</div>
                      }
                    </div>
                  }
                </div>
              }
              @if (!isAdmin) {
                <div class="col-sm-6">
                  <label
                    class="required-label"
                    for="officeIds"
                    >Standorte</label
                  >
                  <ng-select
                    [formControl]="formGroup.get('officeIds') | formControl"
                    [items]="offices"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="true"
                    id="officeIds"></ng-select>
                </div>
              } @else {
                <div class="col-sm-6">
                  <label for="sendIncidentMail">Vorfall-Mail senden</label>
                  <div class="love-it-checkbox-centered">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="sendIncidentMail"
                      [formControl]="formGroup.get('sendIncidentMail') | formControl" />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </ng-template>
    </li>
  </ul>
  <div class="modal-body">
    <div
      [ngbNavOutlet]="nav"
      class="mt-2"></div>
  </div>
  <div class="modal-footer">
    @if (!isAdmin) {
      <button
        rippleEffect
        type="button"
        class="btn-mobile-group btn-outline-info"
        (click)="resetPassword()">
        Passwort zurücksetzen
      </button>
    }
    <love-it-modal-buttons
      (onSubmit)="onSubmit($event)"
      [dirty]="formGroup.dirty"
      [showSpeichernButton]="CaslAction.Update | permission: EntityTyp.User"></love-it-modal-buttons>
  </div>
</form>
